import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';

import * as Styled from '../LoyaltyPageSeparated.styles';
import { selectors } from '../../LoyaltyPage/reducer';
import * as loyaltyActions from '../../LoyaltyPage/actions';
import { selectors as selectorsLogin } from '../../LoginPage/reducer';
import { selectors as usersSelectors } from '../../../components/ActivePharmacistBlock/reducer';
import * as usersActions from '../../../components/ActivePharmacistBlock/actions';
import { distributeClientBonus } from '../../LoyaltyPage/helpers';

interface LoyaltyHeaderProps {
  showWithBonuses: boolean;
  isStadaBonusesCredit: boolean;
}

const LoyaltyHeader = ({
  showWithBonuses,
  isStadaBonusesCredit,
}: LoyaltyHeaderProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const dataUser = useSelector(selectorsLogin.userData);
  const activeUsers = useSelector(usersSelectors.activeUsersData);
  const clientInfo = useSelector(selectors.clientInfo);
  const chosenReceipt = useSelector(selectors.chosenReceipt);
  const stadaInfo = useSelector(selectors.stadaInfo);
  const pharmacistTodayBonuses = useSelector(selectors.pharmacistTodayBonuses);

  const [currentPharmacist, setCurrentPharmacist] = useState<null | any>(null);

  const stadaBalance = (stadaInfo && stadaInfo.balance) ?? 0;

  const currentItems = distributeClientBonus(
    chosenReceipt?.items ?? [],
    showWithBonuses ? clientInfo?.balance ?? 0 : 0
  );

  const totalBonuses = (bonuses: 'bonusesToClient' | 'bonusesToPharmacist') =>
    currentItems?.reduce((acc, item) => acc + item[bonuses], 0) || 0;

  useEffect(() => {
    if (dataUser) {
      dispatch(
        usersActions.getAllUsers.request({ sourceCode: dataUser.sourceCode })
      );
    }
  }, [dataUser]);

  useEffect(() => {
    dispatch(loyaltyActions.getPharmacistTodayBonuses.request());
  }, []);

  useEffect(() => {
    if (activeUsers) {
      setCurrentPharmacist(
        activeUsers?.find(
          (pharmacist: any) => pharmacist.phone === dataUser?.phone
        )
      );
    }
  }, [activeUsers, dataUser]);

  return (
    <Styled.HeaderFixed>
      <Styled.HeaderLeft>
        <Styled.HeaderInfoItem>
          <span className="header-label">
            {t('LoyaltySeparated.PHARMACY')}:
          </span>
          <span className="header-value">{dataUser?.networkName}</span>
        </Styled.HeaderInfoItem>

        <Styled.HeaderDividerVertical />

        <Styled.HeaderInfoItem>
          <span className="header-label">
            {t('LoyaltySeparated.PHARMACIST')}:
          </span>
          <span className="header-value">
            {currentPharmacist?.name ?? dataUser?.phone}
          </span>
          <Styled.ClientBadgeHeader active={!!clientInfo}>
            {totalBonuses('bonusesToPharmacist') ?? ''} Б
          </Styled.ClientBadgeHeader>
        </Styled.HeaderInfoItem>

        <Styled.HeaderInfoItem>
          <span className="header-label">
            {t('LoyaltySeparated.PHARMACIST_TODAY_BALANCE')}:
          </span>
          <Styled.ClientBadgeHeader active={!!clientInfo}>
            {pharmacistTodayBonuses ?? 0} Б
          </Styled.ClientBadgeHeader>
        </Styled.HeaderInfoItem>

        <Styled.ClientBadgeHeader active={!!clientInfo}>
          {clientInfo ? (
            <>
              {t('LoyaltySeparated.CLIENT_SHORT')}:{' '}
              <span className="bonus-value">
                {'balance' in clientInfo ? clientInfo.balance : 0}{' '}
                {t('LoyaltySeparated.BONUS_SHORT')}
              </span>
            </>
          ) : (
            t('LoyaltySeparated.CLIENT_NOT_ADDED_SHORT')
          )}
        </Styled.ClientBadgeHeader>

        {/* Штадовские бонусы клиента — показываем только если клиент добавлен и есть баланс */}
        {clientInfo &&
          stadaInfo &&
          isStadaBonusesCredit &&
          stadaBalance > 0 && (
            <Styled.ClientBadgeHeader active>
              {t('LoyaltySeparated.STADA_SHORT')}:{' '}
              <span className="bonus-value">
                {stadaBalance} {t('LoyaltySeparated.BONUS_SHORT')}
              </span>
            </Styled.ClientBadgeHeader>
          )}
      </Styled.HeaderLeft>
    </Styled.HeaderFixed>
  );
};

export default LoyaltyHeader;
